///
/// EarthBrowser
///
/// Migration v17 → v18: Add Git Config State
///
/// Adds gitConfig slice for remote repository configuration
///
/// Created by Matt Giger on December 27, 2025
/// Copyright (c) 2025 Geodata Labs
///

interface StateV17 {
	gitConfig?: unknown
}

/**
 * Migrate from v17 to v18
 * Adds gitConfig slice with remote repository configuration
 */
export function migrateV17toV18(state: unknown): unknown {
	// Create a shallow copy of the state
	const nextState = { ...(state as StateV17) }

	// Add gitConfig slice if it doesn't exist
	if (!nextState.gitConfig) {
		nextState.gitConfig = {
			remotes: {},
			credentials: {},
			defaultRemote: null,
			autoFetch: false,
			autoFetchInterval: 15,
			lastFetch: {},
			lastPush: {}
		}
	}

	return nextState
}
